import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useSelector } from "react-redux";
import { isAccessTokenValid } from "../utils/validateToken";
import { Pencil, Trash } from "lucide-react";
import { authAxios } from "../utils/axiosConfig";
import ModalEditUser from "./ModalEditUser";
import ModalDeleteUser from "./ModalDeleteUser";
import "../styles/usersCard.css"

const Card = ({ firstname, lastname, email, userId,	userRole,	gender,	address }) => {
	const { accessToken, role } = useSelector((state) => state.auth);
	const isTokenValid = isAccessTokenValid(accessToken);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [userInfo, setUserInfo] = useState({})

	useEffect(() => {
		if (!isTokenValid) {
			toast.error("Session expired. Please log in again.");
		}
	}, [isTokenValid]);

	const handleUpdateUser = async (userId) => {
		try {
			const response = await authAxios.get(`/api/users/${userId}`);
			return setUserInfo(response.data)
		} catch (error) {
			console.error(error);
			toast.error("Failed to fetch user data. Please try again.");
		} finally {
			setShowEditModal(true)
		}
	};

	return (
		<>
			<li className="card">
				<p className="card_item">Name:	<span>{firstname} {lastname}</span></p>
				<p className="card_item">Email: <span>{email}</span></p>
				<p className="card_item">User ID: <span>{userId}</span></p>
				<p className="card_item">Role: <span>{userRole}</span></p>
				<p className="card_item">Gender: <span>{gender}</span></p>
				<p className="card_item">Address: <span>{address}</span></p>

				{isTokenValid && role === "admin" && (
					<div className="btn_wrapper">
						<button	
							className="btn_delete" 
							disabled={userRole === "admin"} 
							onClick={() => setShowDeleteModal(true)}>
							<Trash size={16} className="icon_delete" /> Delete
						</button>

						<button	onClick={() => handleUpdateUser(userId)} className="btn_update">
							<Pencil	size={16}	className="icon_delete" />Update
						</button>
					</div>
				)}
			</li>

			{showDeleteModal && 
				<ModalDeleteUser userId={userId} email={email} showDeleteModal={setShowDeleteModal}/>}
			{showEditModal && 
				<ModalEditUser userInfo={userInfo} showEditModal={setShowEditModal}/>}
		</>
	);
};

export default Card;
